import { render, staticRenderFns } from "./BadgeJuragan.vue?vue&type=template&id=7a19e4ac&scoped=true&"
var script = {}
import style0 from "./BadgeJuragan.vue?vue&type=style&index=0&id=7a19e4ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a19e4ac",
  null
  
)

export default component.exports